import { Box, Divider, SxProps, Theme, Typography } from "@mui/material";
import { useContext } from "react";
import { LayoutsConfig, MainContext } from "../context/MainContextProvider";

export default function CardBox(props: {
  children?: React.ReactNode;
  sx?: SxProps<Theme>;
  onClick?: () => void;
  dateLeft?: string;
  widthTopCalc?: string;
  leftTopCalc?: number;
  removeShadow?: boolean
}) {
  const { theme, layout } = useContext(MainContext);
  return (
    layout == LayoutsConfig.LayoutOne ?
      <Box
        onClick={props.onClick}
        sx={{
          backgroundColor: "transparent",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-around",
          flexWrap: "wrap",
          padding: "10px",
          position: "relative",
          ...props.sx,
        }}
      >
        {props.dateLeft ? (
          <>
            <Typography
              sx={{
                position: "absolute",
                top: -15,
                left: 15,
                color: theme.cardBorderColor,
                fontSize: "13px",
                fontWeight: "500",
                padding: "5px",
              }}
            >
              {props.dateLeft}
            </Typography>
            <Divider
              orientation="horizontal"
              flexItem
              sx={{
                backgroundColor: theme.cardBorderColor,
                width: `calc(100% - ${props.widthTopCalc ?? "160"}px)`,

                position: "absolute",
                top: 0,
                left: props.leftTopCalc ?? 145,
              }}
            />
          </>
        ) : (
          <Divider
            orientation="horizontal"
            flexItem
            sx={{
              backgroundColor: theme.cardBorderColor,
              width: "calc(100% - 30px)",
              position: "absolute",
              top: 0,
              left: 15,
            }}
          />
        )}
        <Divider
          orientation="horizontal"
          flexItem
          sx={{
            backgroundColor: theme.cardBorderColor,
            width: "calc(100% - 30px)",
            position: "absolute",
            bottom: 0,
            left: 15,
          }}
        />
        <Divider
          orientation="vertical"
          flexItem
          sx={{
            backgroundColor: theme.cardBorderColor,
            height: "calc(100% - 30px)",
            position: "absolute",
            left: 0,
            top: 15,
          }}
        />
        <Divider
          orientation="vertical"
          flexItem
          sx={{
            backgroundColor: theme.cardBorderColor,
            height: "calc(100% - 30px)",
            position: "absolute",
            right: 0,
            top: 15,
          }}
        />
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            height: "10px",
            borderLeft: `2px solid ${theme.cardBorderColor}`,
            borderTop: `2px solid ${theme.cardBorderColor}`,
            width: "10px",
            marginRight: "10px",
            marginBottom: "10px",
          }}
        />
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            height: "10px",
            borderLeft: `2px solid ${theme.cardBorderColor}`,
            borderBottom: `2px solid ${theme.cardBorderColor}`,
            width: "10px",
          }}
        />
        <Box
          sx={{
            position: "absolute",
            top: 0,
            right: 0,
            height: "10px",
            borderRight: `2px solid ${theme.cardBorderColor}`,
            borderTop: `2px solid ${theme.cardBorderColor}`,
            width: "10px",
          }}
        />
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            right: 0,
            height: "10px",
            borderRight: `2px solid ${theme.cardBorderColor}`,
            borderBottom: `2px solid ${theme.cardBorderColor}`,
            width: "10px",
          }}
        />
        {props.children}
      </Box> :
      <Box
        onClick={props.onClick}
        sx={{
          backgroundColor: "transparent",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-around",
          flexWrap: "wrap",
          padding: "10px",
          position: "relative",
          boxShadow: props.removeShadow ? "none" : "4px 4px 10px rgba(0, 0, 0, 0.3)",
          borderRadius: "8px",
          ...props.sx,
        }}
      >
        {props.dateLeft && (
          <>
            <Typography
              sx={{
                position: "absolute",
                top: -15,
                left: 15,
                color: theme.cardBorderColor,
                fontSize: "13px",
                fontWeight: "500",
                padding: "5px",
              }}
            >
              {props.dateLeft}
            </Typography>
          </>
        )}
        {props.children}</Box>
  );
}
